import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { LoadingButtonComponent } from '../loading-button/loading-button.component';

export type LoginLoadingAction = 'signin' | 'signup' | 'google' | null;
export type LoginMode = 'signin' | 'signup';

@Component({
  selector: 'app-login-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, LoadingButtonComponent],
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
})
export class LoginModalComponent {
  @Input() isOpen = false;
  @Input() loading = false;
  @Input() loadingAction: LoginLoadingAction = null;
  @Input() error = '';
  @Input() title = 'Sign in';
  @Input() message = 'Sign in to continue.';
  @Input() showPasswordForm = true;
  @Input() showGoogleButton = true;
  @Input() signInLabel = 'Sign in';
  @Input() signUpLabel = 'Create account';
  @Input() googleButtonLabel = 'Continue with Google';
  @Input() closeLabel = 'Close';
  @Input() emailPlaceholder = 'you@example.com';
  @Input() mode: LoginMode = 'signin';

  @Output() dismiss = new EventEmitter<void>();
  @Output() signInRequested = new EventEmitter<{ email: string; password: string }>();
  @Output() signUpRequested = new EventEmitter<{ email: string; password: string; passwordConfirmation: string }>();
  @Output() signInWithGoogleRequested = new EventEmitter<void>();

  email = '';
  password = '';
  passwordConfirmation = '';

  submitSignIn(): void {
    this.signInRequested.emit({
      email: this.email.trim(),
      password: this.password,
    });
  }

  submitSignUp(): void {
    this.signUpRequested.emit({
      email: this.email.trim(),
      password: this.password,
      passwordConfirmation: this.passwordConfirmation,
    });
  }

  setMode(mode: LoginMode | string | number | undefined | null): void {
    this.mode = mode === 'signup' ? 'signup' : 'signin';
  }

  requestGoogleSignIn(): void {
    this.signInWithGoogleRequested.emit();
  }

  handleDidDismiss(): void {
    this.resetForm();
    this.dismiss.emit();
  }

  close(): void {
    this.dismiss.emit();
  }

  private resetForm(): void {
    this.email = '';
    this.password = '';
    this.passwordConfirmation = '';
    this.mode = 'signin';
  }
}
